import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arkOne/headIcon.png'
import _imports_1 from '@/assets/arkOne/tip.png'


const _withScopeId = n => (_pushScopeId("data-v-24c2ddaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strategy-header" }
const _hoisted_2 = {
  key: 0,
  class: "header-content"
}
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "header-top" }
const _hoisted_5 = { class: "strategy-name" }
const _hoisted_6 = { class: "strategy-tags" }
const _hoisted_7 = { class: "strategy-highlights" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "headIcon",
  src: _imports_0
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "组合亮点:", -1))
const _hoisted_10 = { class: "header-right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tipIcon",
  src: _imports_1
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "风险提示", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"risk-modal-header\" data-v-24c2ddaf><svg class=\"warning-icon\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-24c2ddaf><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#FFA500\" stroke=\"#FF8C00\" stroke-width=\"1.5\" data-v-24c2ddaf></circle><path d=\"M12 7v6M12 15v1\" stroke=\"#FFFFFF\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-24c2ddaf></path></svg><span class=\"risk-title\" data-v-24c2ddaf>风险提示</span></div><div class=\"risk-modal-content\" data-v-24c2ddaf><p data-v-24c2ddaf>以上资讯、数据不构成销售或建议任何投资、交易策略或金融产品的要约或招揽。投资未必一定能够赚取利润，反而可能会招致损失。据此操作，一切损失与万众金融控股有限公司无关。</p></div>", 2)
const _hoisted_16 = { class: "risk-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.displayName), 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTags, (tag, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: "tag"
                  }, _toDisplayString(tag), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.displayHighlights), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "risk-warning",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRiskWarning && _ctx.showRiskWarning(...args)))
            }, _hoisted_13)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isRiskWarningVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "risk-modal-overlay",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeRiskWarning && _ctx.closeRiskWarning(...args)))
        }, [
          _createElementVNode("div", {
            class: "risk-modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "confirm-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeRiskWarning && _ctx.closeRiskWarning(...args)))
              }, "知道了")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}